export default {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getPaginatedPosts(_, page) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/blog/index?page=" + page)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        deletePost(_, identifier) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/blog/delete/" + identifier)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        createPost(_, data) {
            let formData = new FormData();
            Object.keys(data).forEach(key => {
                if (data[key]) {
                    formData.append(key, data[key])
                }
            });
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/blog/store", formData)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        updatePost(_, payload) {
            let formData = new FormData();
            Object.keys(payload.data).forEach(key => {
                if (payload.data[key]) {
                    formData.append(key, payload.data[key])
                }
            });
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/blog/update/" + payload.identifier, formData)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        singlePost(_, identifier) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/blog/show/" + identifier)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        togglePostStatus(_, identifier) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/blog/toggle-status/" + identifier)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        postComments(_, identifier) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/blog/comments/" + identifier)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        deleteComment(_, id) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/blog/comments/delete/" + id)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        replyComment(_, data) {
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/blog/comments/reply/" + data.identifier, {
                    comment: data.comment
                })
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
    },
}

